export class NaturezaDespesa {
    id: number =  0;
    nome: string = ""
}